/**
 * VLX Dropdown
 * Vanilla JS dropdown for navigation
 */

(function () {
    "use strict";

    const VLX = (window.VLX = window.VLX || {});

    class Dropdown {
        constructor(toggle) {
            this.toggle = toggle;
            this.parent = toggle.closest(".dropdown");
            this.menu = document.getElementById(toggle.getAttribute("aria-controls"));

            if (!this.parent || !this.menu) return;

            // Ensure initial hidden state is consistent
            if (!this.menu.hasAttribute("hidden") && !this.parent.classList.contains("is-open")) {
                this.menu.setAttribute("hidden", "");
            }

            this.isOpen = this.parent.classList.contains("is-open");
            this.updateAria();
            this.bindEvents();
        }

        bindEvents() {
            // ESC closes dropdown
            this.parent.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    this.hide();
                    this.toggle.focus();
                }
            });
        }

        show() {
            if (this.isOpen) return;
            if (!this.dispatch("show")) return;

            Dropdown.closeAll();

            this.isOpen = true;
            this.parent.classList.add("is-open");
            this.menu.removeAttribute("hidden");
            this.toggle.setAttribute("aria-expanded", "true");

            this.dispatch("shown");
        }

        hide() {
            if (!this.isOpen) return;
            if (!this.dispatch("hide")) return;

            this.isOpen = false;
            this.parent.classList.remove("is-open");
            this.menu.setAttribute("hidden", "");
            this.toggle.setAttribute("aria-expanded", "false");

            this.dispatch("hidden");
        }

        toggleDropdown() {
            this.isOpen ? this.hide() : this.show();
        }

        updateAria() {
            this.toggle.setAttribute("aria-expanded", String(this.isOpen));
        }

        dispatch(name) {
            const event = new CustomEvent(`vlx.dropdown.${name}`, {
                cancelable: true,
                detail: {
                    toggle: this.toggle,
                    menu: this.menu,
                },
            });
            return this.parent.dispatchEvent(event);
        }

        static closeAll() {
            document.querySelectorAll(".dropdown.is-open").forEach((item) => {
                const toggle = item.querySelector('[data-toggle="dropdown"]');
                if (!toggle) return;

                const menu = document.getElementById(toggle.getAttribute("aria-controls"));

                item.classList.remove("is-open");
                toggle.setAttribute("aria-expanded", "false");
                if (menu) menu.setAttribute("hidden", "");

                // keep instance state in sync
                if (toggle.__vlxDropdown) {
                    toggle.__vlxDropdown.isOpen = false;
                }
            });
        }
    }

    // Close on outside interaction (runs before click)
    document.addEventListener("pointerdown", function (e) {
        const insideDropdown = e.target.closest(".dropdown");
        if (!insideDropdown) {
            Dropdown.closeAll();
        }
    });

    // Data API (toggle on click)
    document.addEventListener("click", function (e) {
        const toggle = e.target.closest('[data-toggle="dropdown"]');
        if (!toggle) return;

        e.preventDefault();

        let instance = toggle.__vlxDropdown;
        if (!instance) {
            instance = new Dropdown(toggle);
            toggle.__vlxDropdown = instance;
        }

        instance.toggleDropdown();
    });

    VLX.Dropdown = Dropdown;
})();
